// AuthContext.js
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface AuthContextProps {
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(!!localStorage.getItem('authToken'));
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    console.log(userInfo)
    if (userInfo?.isPasswordVerified && location.pathname === '/login') {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if(userInfo?.roles !=='READER'){
        if(userInfo.roles ==='SALES_MANAGER' || userInfo.roles ==='SALES_TEAM_LEAD' || userInfo.roles ==='SALES_EXECUTIVE'){
          navigate('/portals/leads/viewUser');
      }else if(userInfo.roles ==='JUNIOR_EDITOR' || userInfo.roles ==='CHIEF_EDITOR' || userInfo.roles ==='PUBLISHER' || userInfo.roles ==='UPLOADER'){
          navigate('/portals/posts/viewPosts');
      }
      else {
          navigate('/portals/userManagmnt/viewUser');
      }
      }
    }
  }, [isAuthenticated, navigate, location.pathname]);
  const login = (token: string) => {
    localStorage.setItem('authToken', token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
